// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"f427d347","123":"3a5cde50","189":"76d463f4","372":"44d500fd","477":"d27497df","689":"6766db99","820":"cfc91576"}[chunkId] + ".chunk.css";
};